var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "row margin-top" }, [
        _c("div", { staticClass: "col-8 offset-2" }, [
          _c("div", { staticClass: "row medium-font" }, [
            _vm.claim === null
              ? _c("div", { staticClass: "col text-center" }, [_vm._m(0)])
              : _c("div", [
                  _vm.claim.settlement_customer_approved
                    ? _c("div", { staticClass: "col text-center" }, [
                        _vm.noteSent
                          ? _c("div", [
                              _c("p", [
                                _c("strong", [
                                  _vm._v(
                                    "\n                    You have accepted settlement amount of $" +
                                      _vm._s(_vm.claim.settlement_amount) +
                                      " for move " +
                                      _vm._s(_vm.claim.ref_id) +
                                      ".\n                    Customer care agent will get in touch shortly so that your complaint can be resolved.\n                  "
                                  )
                                ])
                              ])
                            ])
                          : _c("div", [
                              _c("p", [
                                _vm._v(
                                  "\n                  Let us know if you wish to receive the refund via check or on credit card and confirm that the card used for the payment of the service is still valid and active.\n                "
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col pr-1 pb-3" }, [
                                _c("div", { staticClass: "select-wrap" }, [
                                  _c("label", [_vm._v("Note")]),
                                  _vm._v(" "),
                                  _c("textarea", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.note,
                                        expression: "note"
                                      }
                                    ],
                                    staticClass:
                                      "form-control select-wrap-textarea",
                                    attrs: { cols: "80", rows: "5" },
                                    domProps: { value: _vm.note },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.note = $event.target.value
                                      }
                                    }
                                  })
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-primary ld-ext-right",
                                    attrs: { type: "button" },
                                    on: { click: _vm.sendNote }
                                  },
                                  [
                                    _vm._v(
                                      "\n                    Send\n                  "
                                    )
                                  ]
                                )
                              ])
                            ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.claim.settlement_customer_approved
                    ? _c("div", { staticClass: "col text-center" }, [
                        _c("p", [
                          _c("strong", [
                            _vm._v(
                              "\n                  You have rejected settlement amount of $" +
                                _vm._s(_vm.claim.settlement_amount) +
                                " for move " +
                                _vm._s(_vm.claim.ref_id) +
                                ".\n                  Customer care agent will get in touch shortly so that your complaint can be resolved.\n                "
                            )
                          ])
                        ])
                      ])
                    : _vm._e()
                ])
          ])
        ]),
        _vm._v(" "),
        _vm._m(1)
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("strong", [_vm._v("\n                Please wait...\n              ")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-8 offset-2" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col text-right" }, [
          _c("a", { staticClass: "thick-font", attrs: { href: "#" } }, [
            _vm._v("Need help?")
          ]),
          _c("br"),
          _vm._v(" "),
          _c("p", { staticClass: "info-text" }, [
            _vm._v("Visit our knowledge base")
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4cd0f27c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4cd0f27c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/claims/ClaimConfirm.vue
// module id = null
// module chunks = 